import Vue from 'vue'
import VueRouter from 'vue-router'
import router_modular from '@/router/router_modular/index.js'
import { getToken, removeToken } from '@/utils/auth'
import { UserModule } from '@/store/store_modular/user';
import { setSessionStorage, getSessionStorage } from '@/utils/utils'
Vue.use(VueRouter)

// 路由集合模板语法
const routes = [
  ...router_modular
]

const scrollBehavior = (to, from, savedPosition) => {
  if (savedPosition) {
    return savedPosition;
  } else {
    return { x: 0, y: 0 };
  }
};
// 路由实例创建 配置
const createRouter = () =>
  new VueRouter({
    mode: 'hash',
    scrollBehavior,
    base: process.env.BASE_URL,
    routes,
  });
// 创建实例
  const router = createRouter();

  // 重置路由
// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
export function resetRouter() {
  const newRouter = createRouter();
  router.matcher = newRouter.matcher; // reset router
}

// 全局前置路由守卫
/**
 * 全局前置守卫，组件初始化时调用，每次路由切换之前调用
 * A路由组件，切换到B路由组件，那么前置路由守卫就是我点了切换按钮，但B路由组件还没有被呈现在页面上的时候被调用。
 */
router.beforeEach(async (to,_,next)=>{
  // 判断雇员是否已经登录，通过是否获取到了正确的token数据信息来判断
  if(getToken()){
    // 如果token有值表示已登录，则重定向到首页
    if(to.path === '/'){
      next({ path: '/home' });
    } else {
    const projectId = getSessionStorage('projectId');
    // 如果存储没有值，表示 第一次进入需要给这个雇员第一个项目的信息 同时，获取到这个项目内 这个雇员的个人信息
    if(to.name === 'home' && !projectId){
      await UserModule.getProjectList();
      
      if (UserModule.projectList === undefined) {
        removeToken();
        next(`/`);
        return;
      }
      const now = UserModule.projectList[0]; // 一个项目的信息
      setSessionStorage('nowProject', JSON.stringify(now));
      setSessionStorage('projectId', now.projectId);
      await UserModule.getEmInfo(now.projectId); // 获取雇员信息
      const employeeObj = UserModule.employeeInfo;
      setSessionStorage('employeeInfo', JSON.stringify(employeeObj));
      setSessionStorage('employeeId', JSON.stringify(employeeObj.employeeId));
      next();
    } else {
      next();
    }

    }
  } else {
    if (to.path === '/') {
      console.log('login');
      sessionStorage.clear();
      next();
    } else {
      console.log('login redirect');
      sessionStorage.clear();
      next(`/`); // 否则全部重定向到登录页
    }
  }
  // console.log(to,_,next);
})

// 全局后置路由守卫
/**
 * 全局后置守卫，组件初始化时调用，每次路由切换之后调用
 * 在A路由组件，切换到B路由组件，那么前置路由守卫就是在点了切换按钮B路由组件呈现到页面后被调用
 */
router.afterEach((to)=>{
  if(to.meta.title){
    document.title = to.meta.title;
  }
})


export default router
